// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"399d243d","453":"88c992e3"}[chunkId] + ".chunk.js";
};